export enum CustomLocale {
  EN = 'en',
  ES = 'es',
  FR = 'fr',
  AR = 'ar',
  RU = 'ru',
}
